<template>
  <button
    v-bind="$attrs"
    :disabled="disabled"
    :class="[
      'rounded-md font-medium transition',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-indigo-500',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      sizeClasses,
      variantClasses,
    ]"
    :title="tooltip"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    variant: { type: String, default: 'primary' },
    size: { type: String, default: 'md' },
    tooltip: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    // ACHTUNG: 'text-white' steht bewusst in JEDER Variante und nicht mehr in den
    // Basisklassen. Sonst kann keine Variante dunkle Schrift tragen: Basis- und
    // Variantenklasse haben dieselbe Spezifitaet, und dann entscheidet nicht das
    // class-Attribut, sondern die Reihenfolge im erzeugten Tailwind-Stylesheet.
    // 'cancel' gewann mit text-gray-800 bisher nur zufaellig (gray steht dort
    // hinter white). Jetzt ist es eine Aussage statt eines Zufalls.
    variantClasses() {
      switch (this.variant) {
        case 'cancel':
          return 'bg-gray-400 hover:bg-gray-500 text-gray-800';
        case 'disabled':
          return 'bg-gray-500 text-white';
        case 'edit':
          return 'bg-yellow-400 hover:bg-yellow-500 text-white';
        case 'delete':
          return 'bg-red-600 hover:bg-red-700 text-white';
        case 'copy':
          return 'bg-cyan-500 hover:bg-cyan-600 text-white';
        case 'switch':
          return 'bg-indigo-500 hover:bg-indigo-600 text-white';
        // Warnende Aktion: sichtbar anders als die bestaetigende Primaeraktion,
        // ohne die Wucht von 'delete'.
        // ACHTUNG: seit dem 18.08. benutzt sie NIEMAND mehr. "Neu bewerten"
        // stand hier als Beispiel und ist ein neutraler Icon-Knopf geworden --
        // weiss auf amber-500 sind 2,15:1, und eine unbeschriftete 16px-
        // Strichgrafik braucht nach WCAG 1.4.11 mindestens 3:1. Die Warnung
        // steht jetzt im Dialog, der als einziger weiss, ob ueberhaupt
        // Bewertungen verloren gehen.
        // Der Fall bleibt trotzdem stehen: confirmVariant kommt zur Laufzeit
        // als Zeichenkette herein, und ein fehlender Fall fiele still auf das
        // emerald des default-Zweigs.
        case 'warning':
          return 'bg-amber-500 hover:bg-amber-600 text-white';
        // Zuruecknehmende Aktion (z. B. "Verwerfen"): heller Grund, dunkle
        // Schrift, sichtbarer Rand. Kontrast gray-700 auf Weiss ca. 10,8:1.
        case 'neutral':
          return 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 hover:border-gray-400';
        default:
          return 'bg-emerald-500 hover:bg-emerald-600 text-white';
      }
    },

    // 'md' ist bitgleich zu den frueheren Basisklassen -- alle Bestandsaufrufe
    // rendern unveraendert.
    sizeClasses() {
      switch (this.size) {
        case 'sm':
          return 'px-2 py-1 text-[11px]';
        case 'icon':
          return 'p-2';
        default:
          return 'px-4 py-2';
      }
    },
  },
};
</script>
